import _ from 'lodash';
import moment from 'moment';
import { HALFTIME, FIRST_PERIOD, SECOND_PERIOD, FIRST_PERIOD_PROLONGATION, SECOND_PERIOD_PROLONGATION, HALFTIME_PROLONGATION } from '../constants';

export const me = () => {
    const me = sessionStorage.getItem('me');

    return me ? { id: JSON.parse(me).id || _.split(JSON.parse(me)['@id'], '/')[3], firstname: JSON.parse(me).firstname, lastname: JSON.parse(me).lastname, nickname: JSON.parse(me).nickname, ssoId: JSON.parse(me).ssoId } : { id: '', firstname: '', lastname: '', nickname: '', ssoId: null };
}

export const getNickname = (firstname, lastname, nickname) => (nickname !== '' && nickname !== undefined && nickname !== null) ? nickname : (lastname && firstname ? `${firstname} ${lastname.charAt(0).toUpperCase()}.` : 'Livescorer');

export const isSpectator = lives => {
    const spectator = [];
    _.forEach(lives, live => {
        if (!_.isEmpty(_.find(live.subscribers, subscriber => subscriber.id === me().id || subscriber['@id'] === `/api/users/${me().id}`))) {
            spectator.push(_.find(live.subscribers, subscriber => subscriber.id === me().id || subscriber['@id'] === `/api/users/${me().id}`))
        }
    });

    return spectator.length > 0
}

export const isLiveScorer = lives => !_.isEmpty(_.find(lives, live => live && !_.isEmpty(live) && me() && live.author && (live.author.id === me().id || live.author.id === `/api/users/${me().id}` || live.author['@id'] === `/api/users/${me().id}`)));

export const getOwnLive = lives => _.find(lives, live => (live.author && live.author.id === me().id) || (live.author && live.author['@id'] === `/api/users/${me().id}`));

export const getOwnLiveSpectator = lives => _.find(lives, live => !_.isEmpty(_.find(live.subscribers, s => s['@id'] === `/api/users/${me().id}`)));

export const isLessThanAnHour = date => moment(date, 'YYYYMMDDHm').diff(moment(), 'hours') < 1;

export const formatCompetitionName = (competition, journee, cpType) => `${competition} - ${typeof journee === 'object' ? ((journee.pj_lib_tour && journee.pj_lib_tour !== '') ? journee.pj_lib_tour : (cpType === 'CP' ? `Tour ${journee.pj_no}` : `Journée ${journee.pj_no}`) ) : journee }`;

export const isLiveInProgress = live => !_.isEmpty(live) && live.actions && live.actions.length > 0 && !live.ended;

export const isLiveEnded = live => !_.isEmpty(live) && live.ended;

export const isLiveReadyToOvertime = live => isLiveInProgress(live) && isRegularTimeEnd(live.actions);

export const isRegularTimeEnd = actions => !_.isEmpty(_.last(actions)) ? _.last(actions).data.label === 'fin_temps_reglementaire' : false;

export const isOvertimeEnd = actions => !_.isEmpty(_.find(actions, a => a.data.label === 'fin_prolongations'));

export const isOverTimeStarted = actions => !_.isEmpty(_.find(actions, a => a.data.label === 'prolongations'));

export const isTabStarted = actions => !_.isEmpty(_.find(actions, a => a.data.label === 'tab'));

export const getChronoFromLiveDebut = actions => {
    switch(getLivePeriod(actions)) {
        case FIRST_PERIOD:
            const debut = extractAction(actions, 'debut');
            return debut ? moment(moment(),"HH:mm:ss").diff(moment(debut.data.startAt,"HH:mm:ss"), 'minute') : 0;
        case SECOND_PERIOD:
            const mitemps = extractAction(actions, 'mi_temps');
            const reprise = extractAction(actions, 'reprise');
            const firstPeriodRegularTime = getRegularTimeForAction(actions, mitemps);
            return reprise ? moment(moment(),"HH:mm:ss").diff(moment(reprise.data.startAt,"HH:mm:ss"), 'minute') + firstPeriodRegularTime : 0;
        case FIRST_PERIOD_PROLONGATION:
            const regularTime = extractAction(actions, 'fin_temps_reglementaire');
            const overtime = extractAction(actions, 'prolongations');
            const secondPeriodRegularTime = getRegularTimeForAction(actions, regularTime);
            return overtime ? moment(moment(),"HH:mm:ss").diff(moment(overtime.data.startAt,"HH:mm:ss"), 'minute') + secondPeriodRegularTime : 0;
        case SECOND_PERIOD_PROLONGATION:
            const mitempsOvertime = extractAction(actions, 'mi_temps_prolongation');
            const repriseOvertime = extractAction(actions, 'reprise_prolongation');
            const firstPeriodProlong = getRegularTimeForAction(actions, mitempsOvertime);
            return repriseOvertime ? moment(moment(),"HH:mm:ss").diff(moment(repriseOvertime.data.startAt,"HH:mm:ss"), 'minute') + firstPeriodProlong : 0;
        default: return 0;
    }
}

export const getSecondChrono = actions => {
    let action = {}

    if(getLivePeriod(actions) === FIRST_PERIOD) {
        action = extractAction(actions, 'debut');
    }
    else if(getLivePeriod(actions) === SECOND_PERIOD) {
        action = extractAction(actions, 'reprise');
    }
    else if(getLivePeriod(actions) === FIRST_PERIOD_PROLONGATION) {
        action = extractAction(actions, 'prolongations');
    }
    else if(getLivePeriod(actions) === SECOND_PERIOD_PROLONGATION) {
        action = extractAction(actions, 'reprise_prolongation')
    }

    const startAt = action && !_.isEmpty(action) ? action.data.startAt : '00:00:00';

    return moment.utc(moment(moment(),"HH:mm:ss").diff(moment(startAt,"HH:mm:ss"))).second();
}

export const addScore = (score, category) => _.update(score, category, v => _.toNumber(v) + 1);

export const substractScore = (score, category) => _.update(score, category, v => v > 0 ? _.toNumber(v) - 1 : _.toNumber(v));

export const extract = (chaine, separator, position) => _.split(chaine, separator)[position];

export const userExist = () => me().id !== '' && me().id !== null && me().id !== undefined;

export const getPeriodForAction = (actions, currentAction) => {
    const mitempsIndex = _.findIndex(actions, a => a.data.label === 'mi_temps');
    const overtimeIndex = _.findIndex(actions, a => a.data.label === 'prolongations');
    const mitempsOvertimeIndex = _.findIndex(actions, a => a.data.label === 'mi_temps_prolongation');
    const currentActionIndex = _.findIndex(actions, a => _.isEqual(a, currentAction));

    if(overtimeIndex !== -1 && (_.gt(currentActionIndex, overtimeIndex) || _.eq(currentActionIndex, overtimeIndex))) {
        switch(true) {
            case _.eq(currentActionIndex, mitempsOvertimeIndex) :
                return HALFTIME_PROLONGATION;
            case _.gt(currentActionIndex, mitempsOvertimeIndex) && mitempsOvertimeIndex !== -1:
                return SECOND_PERIOD_PROLONGATION;
            default: return FIRST_PERIOD_PROLONGATION
        }
    }
    else {
        switch(true) {
            case _.eq(currentActionIndex, mitempsIndex):
                return HALFTIME;
            case _.gt(currentActionIndex, mitempsIndex) && mitempsIndex !== -1:
                return SECOND_PERIOD;
            default: return FIRST_PERIOD
        }
    }
}

export const isHighlightActions = action => _.includes(['debut','mi_temps', 'reprise', 'fin_temps_reglementaire', 'prolongations', 'mi_temps_prolongation', 'reprise_prolongation', 'fin_prolongations'], action.data.label);

export const isLastAction = (actions, currentAction) => !_.isEmpty(_.last(actions)) && _.isEqual(currentAction, _.last(actions));

export const isLiveInHalfTime = actions => !_.isEmpty(_.last(actions)) && _.includes(['mi_temps', 'mi_temps_prolongation'], _.last(actions).data.label);

export const getHalfTimeCaracteristique = (actions,period) => {
    const halftimeDebut = _.find(actions, a => a.data.label === 'debut').data.halftime;
    const overtime = _.find(actions, a => a.data.label === 'prolongations');
    const halftimeOT = !_.isEmpty(overtime) ? overtime.data.halftime : halftimeDebut;
    
    switch (period) {
        case FIRST_PERIOD:
            return _.toNumber(halftimeDebut)
        case SECOND_PERIOD:
            return (_.toNumber(halftimeDebut)*2)
        case FIRST_PERIOD_PROLONGATION:
        case HALFTIME_PROLONGATION:
            return (_.toNumber(halftimeDebut)*2) + _.toNumber(halftimeOT);
        case SECOND_PERIOD_PROLONGATION:
            return (_.toNumber(halftimeDebut)*2) + (_.toNumber(halftimeOT)*2);
        default:
            return _.toNumber(halftimeDebut)
    }

}

export const getRegularTimeForAction = (actions, action) => {
    const period = getPeriodForAction(actions, action);
    const halftime= getHalfTimeCaracteristique(actions, period);

    return halftime < _.toNumber(action.minute) ? halftime : action.minute
}

export const getAdditionalTime = (actions, action) => {
    const period = getPeriodForAction(actions, action);
    const halftime= getHalfTimeCaracteristique(actions, period);

    return halftime < _.toNumber(action.minute) ? (_.toNumber(action.minute) - halftime) : 0
}

export const extractAction = (actions, type) => _.find(actions, a => a.data.label === type);

export const getLivePeriod = actions => {
    if(isLiveInHalfTime(actions)) {
        return HALFTIME;
    }
    else if(!_.isEmpty(_.find(actions, a => getPeriodForAction(actions, a) === SECOND_PERIOD_PROLONGATION))) {
        return SECOND_PERIOD_PROLONGATION;
    }
    else if(!_.isEmpty(_.find(actions, a => getPeriodForAction(actions, a) === FIRST_PERIOD_PROLONGATION)) || isOverTimeStarted(actions)) {
        return FIRST_PERIOD_PROLONGATION;
    }
    else if(!_.isEmpty(_.find(actions, a => getPeriodForAction(actions, a) === SECOND_PERIOD))) {
        return SECOND_PERIOD
    }
    else {
        return FIRST_PERIOD
    }
}

export const isDemo = live => (_.isObject(live) && extract(live['@id'], '/', 3) === 'demo') || (_.isString(live) && live === 'demo');

export const resetCaches = () => {
    for(let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        try {
            const cache = JSON.parse(localStorage.getItem(key));
            if (moment().unix() - cache.cache_ttl_expires_at >= 0) {
                localStorage.removeItem(key);
            }
        } catch (error) {
            console.error(`Error parsing JSON for key "${key}":`, error);
        }
    }
};


export const isLiveAlreadyRated = live => !_.isEmpty(live) && !_.isEmpty(_.find(live.grades, grade => _.toNumber(extract(grade.user['@id'], '/', 3)) === _.toNumber(me().id) ))

export const getCookie = (name) => {
    const cookie = document.cookie.split('; ').find(row => row.startsWith(name));

    if (cookie) {
        return cookie.split('=')[1];
    } else {
        return null;
    }
}

export const getUserProfile = (firstname, lastname, nickname = '') => {
    if (nickname && nickname !== '') {
        const pattern = /(\d+)|\s/;
        const split = nickname.split(pattern);
        const filter = split.filter(el => el && el !== undefined);
        
        if (filter.length >= 2) {
            return `${filter[0].charAt(0).toUpperCase()}${!isNaN(parseInt(filter[1])) ? filter[1] : filter[1].charAt(0).toUpperCase()}`
        }
    }

    return `${firstname.charAt(0).toUpperCase()}${lastname.charAt(0).toUpperCase()}`;
}